import { ActivityEntityName } from '../';

export enum EntityLinkCommands {
    Add = 'Add',
    Remove = 'Remove'
}

export type EntityLinkCommandRequest =
    {
        commandId: EntityLinkCommands.Add;
        data: {
            id: string;
            type: ActivityEntityName;
            links: EntityLinkData;
        }
    } |
    {
        commandId: EntityLinkCommands.Remove;
        data: {
            id: string;
            type: ActivityEntityName;
            deleteIds: string[];
        }
    }

export type EntityLinkData = Record<ActivityEntityName | string, any[]>;